import { importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { NgxsModule } from '@ngxs/store';
import { provideDepotDomain } from '@zero/depot/domain';
import { MoneyAccountEffects } from './+state/money-account/money-account.effects';
import { moneyAccountFeature } from './+state/money-account/money-account.reducers';
import { MoneyTransactionsEffects } from './+state/money-transactions/money-transactions.effects';
import { moneyTransactionsFeature } from './+state/money-transactions/money-transactions.reducers';
import { PositionsEffects } from './+state/positions/positions.effects';
import { positionsFeature } from './+state/positions/positions.reducers';
import { WatchlistEffects } from './+state/watchlist/watchlist.effects';
import { watchlistFeature } from './+state/watchlist/watchlist.reducers';
import { AlertStateModule } from './state/alert/alert.state';
import { AuthStateModule } from './state/auth/auth.state';
import { CustomerStateModule } from './state/customer/customer.state';
import { MaintenanceWorkStateModule } from './state/maintenance-work/maintenance-work.state';

export const provideGlobalSate = () => {
  return makeEnvironmentProviders([
    provideState(positionsFeature),
    provideState(watchlistFeature),
    provideState(moneyTransactionsFeature),
    provideState(moneyAccountFeature),
    provideEffects([PositionsEffects, WatchlistEffects, MoneyTransactionsEffects, MoneyAccountEffects]),
    importProvidersFrom(NgxsModule.forRoot([AuthStateModule, AlertStateModule, CustomerStateModule, MaintenanceWorkStateModule])),
    provideDepotDomain(),
  ]);
};
